// eslint-disable-next-line
import React from 'react';
// eslint-disable-next-line
import * as Yup from 'yup';

function AddPlayerForm() {
  return null;
}

export default AddPlayerForm;